<template>
<!--  рекурсивный компонент дерева категорий-->
  <ul class="c-category-list ml-2.5 lg:m-0 divide-y lg:divide-y-0">
    <li v-for="(category, index) in categoriesList"
        :key="category.id"
        class="p-0 lg:py-2 lg:pl-3">
      <template v-if="category.children && category.children.length > 0">
        <collapsible-list :is-open="isOpen(index)">
          <template #toggle>
            <div class="py-4 lg:py-1 cursor-pointer"
            :class="classDeepLevel(deepLevel)">
              <div class="flex items-center">
                <div class="mr-5">
                  <span class="lg:border-b border-current">{{ category.name }}&nbsp;({{category.children.length}})</span>
                </div>
                <div class="ml-auto transform transition-transform duration-300">
                  <icon-base viewBox="0 0 14 12" width="7" height="6">
                    <icon-sort-down/>
                  </icon-base>
                </div>
              </div>
            </div>
          </template>
          <template #body>
<!--            <div class="border-l">-->
              <categories-list :categoriesList="category.children"
                               :selectedCategory="selectedCategory"
                               :is-root="isOpen(index)"
                               :deepLevel="deepLevel + 1"
                               @selectCategory="selectCategory"/>
<!--            </div>-->
          </template>
        </collapsible-list>
      </template>
      <div v-else class="c-category-list__category-last py-3.5 lg:p-0 cursor-pointer hover:text-primary-bright"
           :class="[classDeepLevel(deepLevel), { active: isSelected(category.id) }]"
           @click="selectCategory(category)">
        <span class="lg:border-b border-current" >{{ category.name }}</span>
      </div>
    </li>
  </ul>
</template>

<script>

import IconBase from "../icons/IconBase.vue";
import IconSortDown from "../icons/IconSortDown.vue";
import CollapsibleList from "../ui/CollapsibleList.vue";

export default {
  name: 'CategoriesList',
  components: {IconSortDown, IconBase, CollapsibleList},

  props: {
    categoriesList: {
      type: Array,
      default: []
    },
    selectedCategory: {
      type: Object,
      default: null
    },
    isRoot: {
      type: Boolean,
      default: false
    },
    deepLevel: {
      type: Number,
      default: 1
    }
  },

  methods: {
    isOpen(index) {
      return this.isRoot && index === 0
    },
    isSelected(categoryId) {
      return Boolean(this.selectedCategory) && this.selectedCategory.id === categoryId
    },
    selectCategory(category) {
      this.$emit('select-category', category);
    },
    classDeepLevel(deepLevel) {
      if (deepLevel < 4) {
        return `deep-level__${deepLevel}`
      }
      else {
        return 'deep-level__4'
      }
    }
  }
}
</script>
